<template>
  <div class="body-nav">
    <ul class="nav-tabs side-nav cf">
      <li :class="{ active: $route.path === '/admin/users' }">
        <Link to="/admin/users">
          <span class="material-icons">group</span>
          <span>{{ $t('meta.users') }}</span>
        </Link>
      </li>
      <li :class="{ active: $route.path === '/admin/companies' }">
        <Link to="/admin/companies">
          <span class="material-icons">business</span>
          <span>{{ $t('meta.companies') }}</span>
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'admin_nav',
  data() {
    return {}
  },
  methods: {},
  mounted() {},
}
</script>
